import { DictionaryFieldsModule, NumberInputModule, ServiceResponseModule } from '@sdbn/common';
import { BasicarticleAttributesComponent } from './basicarticle-attributes/basicarticle-attributes.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';

import { ReactiveFormsModule } from '@angular/forms';

import { DictionaryModule } from '@sdbn/common';
import { CommonDateModule } from '@sdbn/common';
import { BasicArticleAdminComponent } from './basicarticle-admin/basicarticle-admin.component';
import { BasicarticleArticletypeComponent } from './basicarticle-articletype/basicarticle-articletype.component';
import { BasicarticleEditorComponent } from './basicarticle-editor/basicarticle-editor.component';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';

import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
@NgModule({
  declarations: [
    BasicArticleAdminComponent,
    BasicarticleAttributesComponent,
    BasicarticleArticletypeComponent,
    BasicarticleEditorComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,

    ReactiveFormsModule,
    DictionaryModule,
    CommonDateModule,
    NumberInputModule,
    ServiceResponseModule,
    DictionaryFieldsModule,

    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule
  ]
})
export class BasicArticeModule {

}
